export interface BrowserInfo {
  name: string;
  fullVersion: string;
  majorVersion: string;
  appName: string;
  userAgent: string;
}

export const getBrowserInfo = (): BrowserInfo => {
  const userAgent = navigator?.userAgent || 'Unknown';
  console.log('userAgent', userAgent);

  const browserRegex = /(Chrome|Safari|Firefox|Edge)\/(\d+)(\.\d+)*/;
  const match = userAgent.match(browserRegex);

  // console.log('match >>>>>>>>>', match?.[1], match?.[2], match?.[0]);

  return {
    name: match?.[1] || 'Unknown',
    fullVersion: match?.[0].split('/')[1] || 'Unknown',
    majorVersion: match?.[2] || 'Unknown',
    appName: navigator?.appName || 'Unknown',
    userAgent,
  };
};
